module.exports = __webpack_public_path__ + "static/media/TERRITORIALS.3037de85.jpg";